/* tslint:disable:max-line-length */
import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  privacyPolicy: {
    defaultMessage: 'Privacy Policy',
    id: 'LegalDisclaimer.privacyPolicy',
  },
  termsAndConditions: {
    defaultMessage: 'Terms and Conditions',
    id: 'LegalDisclaimer.termsAndConditions',
  },
  termsAndConditionsMessage: {
    defaultMessage:
      "By using the service, you agree to Tink's {termsAndConditions} and {privacyPolicy}.",
    id: 'LegalDisclaimer.termsAndConditionsMessage',
  },
  readMore: {
    defaultMessage: 'Read More',
    id: 'ScopesList.readMore',
  },
  firstTransactionsTitle: {
    defaultMessage: 'Account information',
    id: 'Transactions.firstTitle',
  },
  firstTransactionsBody: {
    defaultMessage:
      'This includes account numbers, balances, account types, loans, interest rates, and other information tied to your accounts.',
    id: 'Transactions.firstBody',
  },
  secondTransactionsTitle: {
    defaultMessage: 'Transaction history',
    id: 'Transactions.secondTitle',
  },
  secondTransactionsBody: {
    defaultMessage: 'This includes deposits, purchases, and refunds in your accounts.',
    id: 'Transactions.secondBody',
  },
});
